export default "__VITE_ASSET__CxjxUytN__"